"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Big error message at the top of the page explaining everything that's wrong
 * with the form fields in this form
 */
const FormError = _ref => {
  let {
    error,
    wrapperClassName,
    wrapperStyle,
    titleClassName,
    titleStyle,
    listClassName,
    listStyle,
    listItemClassName,
    listItemStyle
  } = _ref;
  if (!error) {
    return null;
  }
  let rootMessage = error.message;
  const messages = [];
  const hasGraphQLError = !!error.graphQLErrors?.[0];
  const hasNetworkError = !!error.networkError && (0, _keys.default)(error.networkError).length > 0;
  if (hasGraphQLError) {
    var _error$graphQLErrors$;
    rootMessage = (_error$graphQLErrors$ = error.graphQLErrors[0].message) !== null && _error$graphQLErrors$ !== void 0 ? _error$graphQLErrors$ : 'Something went wrong';

    // override top-level message for ServiceValidation errorrs
    if (error.graphQLErrors[0]?.extensions?.code === 'BAD_USER_INPUT') {
      rootMessage = 'Errors prevented this form from being saved';
    }
    const properties = error.graphQLErrors[0].extensions?.['properties'];
    const propertyMessages = properties && properties['messages'];
    if (propertyMessages) {
      for (const e in propertyMessages) {
        var _context;
        (0, _forEach.default)(_context = propertyMessages[e]).call(_context, fieldError => {
          messages.push(fieldError);
        });
      }
    }
  } else if (hasNetworkError) {
    var _rootMessage;
    rootMessage = (_rootMessage = rootMessage) !== null && _rootMessage !== void 0 ? _rootMessage : 'An error has occurred';
    if (Object.prototype.hasOwnProperty.call(error.networkError, 'bodyText')) {
      const netErr = error.networkError;
      messages.push(`${netErr.name}: ${netErr.bodyText}`);
    } else if (Object.prototype.hasOwnProperty.call(error.networkError, 'result')) {
      const netErr = error.networkError;
      netErr.result.errors?.forEach(error => {
        if (typeof error.message === 'string') {
          var _context2;
          if ((0, _indexOf.default)(_context2 = error.message).call(_context2, ';') >= 0) {
            messages.push(error.message?.split(';')[1]);
          } else {
            messages.push(error.message);
          }
        }
      });
    }
  }
  if (!rootMessage) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: wrapperClassName,
    style: wrapperStyle,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: titleClassName,
      style: titleStyle,
      children: rootMessage
    }), messages.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: listClassName,
      style: listStyle,
      children: (0, _map.default)(messages).call(messages, (message, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
        className: listItemClassName,
        style: listItemStyle,
        children: message
      }, index))
    })]
  });
};
var _default = exports.default = FormError;